import { Tooltip, Trash16 } from '@cian/ui-kit';
import * as React from 'react';

import { IAreaPartDeleteButtonProps } from './types';

export const AreaPartDeleteButton: React.FC<IAreaPartDeleteButtonProps> = props => {
  const { onClick, active } = props;

  const icon = (
    <div onClick={onClick} role="button">
      <Trash16 color={active ? 'primary_100' : 'gray10_100'} data-testid="area-part-delete-button" />
    </div>
  );

  if (!active) {
    return (
      <Tooltip placement="bottom" title="В мультиобъявлении минимум две площади" header="Удалить площадь">
        {icon}
      </Tooltip>
    );
  }

  return icon;
};
